// extracted by css-extract-rspack-plugin
export default {"container":"container-YintzR","icon":"icon-RWixGR","title":"title-Q6TRXV","scheduleContainer":"scheduleContainer-J0PLyg","subtitle":"subtitle-yNDlLO","schedule":"schedule-IWs0m6"};